/**
 * Feature flags for the operator-platform rollout (Phase A milestones).
 *
 * Compile-time constants, not runtime config — each milestone flips its flag
 * in the same PR that ships the feature. Keeping them in one module makes the
 * "what's dark-launched right now" question a one-file read.
 */
export const FLAGS = {
  /** M3 — Fleet Readiness Dashboard at /fleet (operator home). */
  fleet: true,
  /** M4 — Findings & Corrective Actions board at /actions. */
  actions: true,
  /** M5 — Vessel Readiness Pack generation + share links. */
  readinessPack: true,
  /** Multi-standard phase 1 — TMSA 3 operator self-assessment at /tmsa. */
  tmsa: true,
  /** Show the 9 not-yet-live questionnaire templates on TemplatesPage. */
  comingSoonTemplates: false,
} as const;

export type FlagName = keyof typeof FLAGS;
